// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2REfw","empty":"ModalGraph_empty__93185"};